import { useState, useCallback } from 'react';
import type { AppState, TabId, TabState } from '../types';

const initialState: AppState = {
  vp: { r: 'Global', sub: ['All'], status: 'All', fy: ['All'], q: ['All'], dateFrom: '', dateTo: '' },
  sd: { r: 'Global', sub: ['All'], fy: ['All'], q: ['All'], dateFrom: '', dateTo: '' },
  od: { r: 'Global', sub: ['All'], fy: ['All'], q: ['All'], dateFrom: '', dateTo: '' },
};

export function useAppState() {
  const [state, setState] = useState<AppState>(initialState);
  const [currentTab, setCurrentTab] = useState<TabId>('vp');
  const [toast, setToast] = useState<string | null>(null);

  const updateTab = useCallback((tab: TabId, updates: Partial<TabState>) => {
    setState(prev => ({
      ...prev,
      [tab]: { ...prev[tab], ...updates },
    }));
  }, []);

  const switchTab = useCallback((id: TabId) => {
    setCurrentTab(id);
  }, []);

  const drillRegion = useCallback((reg: string, sub: string) => {
    setState(prev => ({
      ...prev,
      sd: { ...prev.sd, r: reg, sub: sub ? [sub] : ['All'] },
    }));
    setCurrentTab('sd');
  }, []);

  const showToast = useCallback((msg: string) => {
    setToast(msg);
    setTimeout(() => setToast(null), 2800);
  }, []);

  return { state, currentTab, toast, updateTab, switchTab, drillRegion, showToast };
}
